import { Heading, Stack, Text } from "@vinomofo/components";

const Description = ({
  heading,
  body,
}: {
  heading: string;
  body: string;
}): JSX.Element => (
  <Stack space={1}>
    <Heading as="h2" fontSize={3}>
      {heading}
    </Heading>
    <Text variant="md" fontSize={2}>
      {body}
    </Text>
  </Stack>
);

export default Description;
